import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";

const InvoiceEmail = ({ show, handleClose }) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false)


    const closeModal = () => {
        handleClose()
    }


    return (
        <Modal show={show} onHide={closeModal} className="modal_pricing">


    
                <div className="modal_body_pricing">
                </div>



                <div className="modal_footer">
                    <ErrorMessage err={err} />

                    <div className="footer_btn_cont">
                        <button disabled={""} className="save_btn">

                            {loading ? (
                                <Spinner loading={loading} />
                            ) : (
                                <><i className="fa-solid fa-save"></i> Save payment method</>
                            )}
                        </button>
                        <button type="button" className="cancel_btn" onClick={closeModal}>{t.cancel}</button>
                    </div>
                </div>
        </Modal>
    );
};

export default InvoiceEmail;
